import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-business-administration',
  templateUrl: './ug-bachelor-of-business-administration.component.html',
  styleUrls: ['./ug-bachelor-of-business-administration.component.scss']
})
export class UgBachelorOfBusinessAdministrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
